import { Container } from 'react-bootstrap';

function App() {
    return (
        <Container>
            <div style={{"display": "flex", "justifyContent": "center", "alignItems": "center"}}>
                <div style={{"maxWidth": "30%", "textAlign": "center"}}>
                    <h5 className='notification'><br/><br/>Welcome</h5>
                </div>
            </div>
        </Container>
    );
}

export default App;